type AdditionalIncentiveInfo = {
  customMessage?: string;
  customClaimMessage?: string;
  customForumLink?: string;
};

type MerklWhitelistConfig = {
  whitelistedRewardTokens: string[];
  additionalIncentiveInfo: Record<string, AdditionalIncentiveInfo>;
};

// Static snapshot of the former whitelist endpoint response
// (previously fetched from https://apps.aavechan.com/api/aave/merkl/whitelist-token-list).
export const EXTRA_WHITELIST_TOKENS: MerklWhitelistConfig = {
  whitelistedRewardTokens: [
    '0xe3190143eb552456f88464662f0c0c4ac67a77eb',
    '0x78f2cb75d664d6f71433174056c25a5958b4016f',
    '0xa1a67b55a88ab8dcc86b765c1cd85887e24ad7aa',
    '0x1ec1609039a9156367c885263fa6dc7ebb350922',
    // New TokenLogic wrapped token addresses
    '0x569ae8d56cb5e36e9585aa625fd64d9211609e54',
    '0x0750e0792898f611592e51aa00d043c14dd4e0d2',
    '0xd2740a43a357ef8b01f975b37efea760e554a9d1',
    '0x1cea01ce975546cc3c9ea83ce3e8395df7779b3f',
    '0x461b1d4ae26b4f4cb627c18ad85f223ef8a0dd18',
    '0x7cea16d8de7b5950905679e7590c7e2b75f6dd0c',
    '0x325fedd0db798eb6ecd1a87eae0bef6f24ec5a08',
    '0x639c16d78d6f8eebabe6afadacaf36f327539584',
    '0xfe2e11bd16f614d79a64d55c79595b76446d2ada',
    '0x046e292396e92ed9e3ca890431dde27e907ae294',
    '0x1a96516e210fbc1026c76f0ce13d9f1d163aaddc',
    '0x9502216a517eba55543d654c7ce3d6ee8cf3556a',
    '0xc5f4afc7da562f51684ae81535da9716c98747df',
    '0x561ad6156d0106e7a59ee788759df7b7ec679bd0',
    '0x5f37e89706EF0CFC52399Ab60d5Ad56b04f98351',
    // END
    '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    '0x4d5F47FA6A74757f35C14fD3a6Ef8E3C9BC514E8',
    '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    '0x0B925eD163218f6662a35e0f0371Ac234f9E9371',
    '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
    '0x5Ee5bf7ae06D1Be5997A1A72006FE6C607eC6DE8',
    '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    '0x98C23E9d8f34FEFb1B7BD6a91B7FF122F4e16F5c',
    '0x6B175474E89094C44Da98b954EedeAC495271d0F',
    '0x018008bfb33d285247A21d44E50697654f754e63',
    '0x514910771AF9Ca656af840dff83E8264EcF986CA',
    '0x5E8C8A7243651DB1384C0dDfDbE39761E8e7E51a',
    '0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9',
    '0xA700b4eB416Be35b2911fd5Dee80678ff64fF6C9',
    '0xBe9895146f7AF43049ca1c1AE358B0541Ea49704',
    '0x977b6fc5dE62598B08C85AC8Cf2b745874E8b78c',
    '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    '0x23878914EFE38d27C4D67Ab83ed1b93A74D4086a',
    '0xae78736Cd615f374D3085123A210448E74Fc6393',
    '0xCc9EE9483f662091a1de4795249E24aC0aC2630f',
    '0x5f98805A4E8be255a32880FDeC7F6728C6568bA0',
    '0x3Fe6a295459FAe07DF8A0ceCC36F37160FE86AA9',
    '0xD533a949740bb3306d119CC777fa900bA034cd52',
    '0x7B95Ec873268a6BFC6427e7a28e396Db9D0ebc65',
    '0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2',
    '0x8A458A9dc9048e005d22849F470891b840296619',
    '0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F',
    '0xC7B4c17861357B8ABB91F25581E7263E08DCB59c',
    '0xba100000625a3754423978a60c9317c58a424e3D',
    '0x2516E7B3F76294e03C42AA4c5b5b4DCE9C436fB8',
    '0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984',
    '0xF6D2224916DDFbbab6e6bd0D1B7034f4Ae0CaB18',
    '0x5A98FcBEA516Cf06857215779Fd812CA3beF1B32',
    '0x9A44fd41566876A39655f74971a3A6eA0a17a454',
    '0xC18360217D8F7Ab5e7c516566761Ea12Ce7F9D72',
    '0x545bD6c032eFdde65A377A6719DEF2796C8E0f2e',
    '0x111111111117dC0aa78b770fA6A738034120C302',
    '0x71Aef7b30728b9BB371578f36c5A1f1502a5723e',
    '0x853d955aCEf822Db058eb8505911ED77F175b99e',
    '0xd4e245848d6E1220DBE62e155d89fa327E43CB06',
    '0x40D16FC0246aD3160Ccc09B8D0D3A2cD28aE6C2f',
    '0x00907f9921424583e7ffBfEdf84F92B7B2Be4977',
    '0xD33526068D116cE69F19A9ee46F0bd304F21A51f',
    '0xB76CF92076adBF1D9C39294FA8e7A67579FDe357',
    '0x83F20F44975D03b1b09e64809B757c47f942BEeA',
    '0x4C612E3B15b96Ff9A6faED838F8d07d479a8dD4c',
    '0xAf5191B0De278C7286d6C7CC6ab6BB8A73bA2Cd6',
    '0x1bA9843bD4327c6c77011406dE5fA8749F7E3479',
    '0xdeFA4e8a7bcBA345F687a2f1456F5Edd9CE97202',
    '0x5b502e3796385E1e9755d7043B9C945C3aCCeC9C',
    '0x3432B6A60D23Ca0dFCa7761B7ab56459D9C964D0',
    '0x82F9c5ad306BBa1AD0De49bB5FA6F01bf61085ef',
    '0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E',
    '0xb82fa9f31612989525992FCfBB09AB22Eff5c85A',
    '0x6c3ea9036406852006290770BEdFcAbA0e23A0e8',
    '0x0C0d01AbF3e6aDfcA0989eBbA9d6e85dD58EaB1E',
    '0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee',
    '0xBdfa7b7893081B35Fb54027489e2Bc7A38275129',
    '0xf1C9acDc66974dFB6dEcB12aA385b9cD01190E38',
    '0x927709711794F3De5DdBF1D176bEE2D55Ba13c21',
    '0x4c9EDD5852cd905f086C759E8383e09bff1E68B3',
    '0x4F5923Fc5FD4a93352581b38B7cD26943012DECF',
    '0xA35b1B31Ce002FBF2058D22F30f95D405200A15b',
    '0x1c0E06a0b1A4c160c17545FF2A951bfcA57C0002',
    '0x9D39A5DE30e57443BfF2A8307A4256c8797A3497',
    '0x4579a27aF00A62C0EB156349f31B345c08386419',
    '0x18084fbA666a33d37592fA2633fD49a74DD93a88',
    '0x10Ac93971cdb1F5c778144084242374473c350Da',
    '0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf',
    '0x5c647cE0Ae10658ec44FA4E11A51c96e94efd1Dd',
    '0xdC035D45d973E3EC169d2276DDab16f1e407384F',
    '0x32a6268f9Ba3642Dda7892aDd74f1D34469A4259',
    '0xA1290d69c65A6Fe4DF752f95823fae25cB99e5A7',
    '0x2D62109243b87C4bA3EE7bA1D91B0dD0A074d7b1',
    '0x8236a87084f8B84306f72007F36F2618A5634494',
    '0x65906988ADEe75306021C417a1A3458040239602',
    '0x657e8C867D8B37dCC18fA4Caead9C45EB088C642',
    '0x5fefd7069a7D91d01f269DADE14526CCF3487810',
    '0x8292Bb45bf1Ee4d140127049757C2E0fF06317eD',
    '0xFa82580c16A31D0c1bC632A36F82e83EfEF3Eec0',
    '0x50D2C7992b802Eef16c04FeADAB310f31866a545',
    '0x4B0821e768Ed9039a70eD1E80E15E76a5bE5Df5F',
    '0x3b3fB9C57858EF816833dC91565EFcd85D96f634',
    '0xDE6eF6CB4aBd3A473ffC2942eEf5D84536F8E864',
    '0xC139190F447e929f090Edeb554D95AbB8b18aC1C',
    '0xEc4ef66D4fCeEba34aBB4dE69dB391Bc5476ccc8',
    '0x917459337CaAC939D41d7493B3999f571D20D667',
    '0x312ffC57778CEfa11989733e6E08143E7E229c1c',
    '0x14Bdc3A3AE09f5518b923b69489CBcAfB238e617',
    '0x2eDff5AF94334fBd7C38ae318edf1c40e072b73B',
    '0x90D2af7d622ca3141efA4d8f1F24d86E5974Cc8F',
    '0x5F9190496e0DFC831C3bd307978de4a245E2F5cD',
    '0xC96dE26018A54D51c097160568752c4E3BD6C364',
    '0xcCA43ceF272c30415866914351fdfc3E881bb7c2',
    '0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c',
    '0xAA6e91C82942aeAE040303Bf96c15a6dBcB82CA0',
    '0x9F56094C450763769BA0EA9Fe2876070c0fD5F77',
    '0x5f4a0873a3A02f7C0CB0e13a1d4362a1AD90e751',
    '0xBC6736d346a5eBC0dEbc997397912CD9b8FAe10a',
    '0x38A5357Ce55c81add62aBc84Fb32981e2626ADEf',
    '0xD11c452fc99cF405034ee446803b6F6c1F6d5ED8',
    '0x481a2acf3A72ffDc602A9541896Ca1DB87f86cf7',
    '0xbf5495Efe5DB9ce00f80364C8B423567e58d2110',
    '0x4E2a4d9B3DF7Aae73b418Bd39F3af9e148E3F479',
    '0x68749665FF8D2d112Fa859AA293F07A622782F38',
    '0x8A2b6f94Ff3A89a03E8c02Ee92b55aF90c9454A2',
    '0xe6A934089BBEe34F832060CE98848359883749B3',
    '0x285866acB0d60105B4Ed350a463361c2d9afA0E2',
    '0x62C6E813b9589C3631Ba0Cdb013acdB8544038B7',
    '0x38C503a438185cDE29b5cF4dC1442FD6F074F1cc',
    '0x1F84a51296691320478c98b8d77f2Bbd17D34350',
    '0xE728577e9a1Fe7032bc309B4541F58f45443866e',
    '0xE8483517077afa11A9B07f849cee2552f040d7b2',
    '0xbe54767735fB7Acca2aa7E2d209a6f705073536D',
    '0xacA92E438df0B2401fF60dA7E4337B687a2435DA',
    '0xAa0200d169fF3ba9385c12E073c5d1d30434AE7b',
    '0x356B8d89c1e1239Cbbb9dE4815c39A1474d5BA7D',
    '0x24Ab03a9a5Bc2C49E5523e8d915A3536ac38B91D',
    '0xe343167631d89B6Ffc58B88d6b7fB0228795491D',
    '0x7c0477d085ECb607CF8429f3eC91Ae5E1e460F4F',
    '0xAeBf0Bb9f57E89260d57f31AF34eB58657d96Ce0',
    '0xE036478Da9A7ed89b56FE39A06e1FC1a4b38D4Ea',
    '0x3de0ff76E8b528C092d47b9DaC775931cef80F49',
    '0x81b76ff3FeD28BA0B4a5D4c76Bd5C13Bd0641d86',
    '0x9Bf45ab47747F4B4dD09B3C2c73953484b4eB375',
    '0x1241ec22C9BdF16BA1Eb636F2a8de7e28A4343Cf',
    '0xB0F70C0bD6FD87dbEb7C10dC692a2a6106817072',
    '0x12b70410D60f926558245f769059eA3Fc7A7353E',
    '0x619D75E3b790eBC21c289f2805Bb7177A7D732E2',
    '0xA78Eba24D89e70A03ddB7AC195A15E53315aA5b4',
    '0x9db38D74a0D29380899aD354121DfB521aDb0548',
    '0xA9ecb0503075124cc0B786096849A331FBe9EE6D',
    '0xC035a7cf15375cE2706766804551791aD035E0C2',
    '0xfA1fDbBD71B0aA16162D76914d69cD8CB3Ef92da',
    '0x09AA30b182488f769a9824F15E6Ce58591Da4781',
    '0x2A1FBcb52Ed4d9b23daD17E1E8Aed4BB0E6079b8',
    '0x74e5664394998f13B07aF42446380ACef637969f',
    '0xc2015641564a5914A17CB9A92eC8d8feCfa8f2D0',
    '0x18eFE565A5373f430e2F809b97De30335B3ad96A',
    '0x56D919E7B25aA42F3F8a4BC77b8982048F2E84B4',
    '0xce8c60fd8390eFCc3Fc66A3f0bd64BEb969e750E',
    '0xbe1F842e7e0afd2c2322aae5d34bA899544b29db',
    '0x7380c583cDe4409eFF5DD3320D93a45D96B80E2e',
    '0xdF7f48892244C6106EA784609f7de10AB36F9c7e',
    '0x6914ECCf50837dC61b43ee478a9BD9B439648956',
    '0x4200000000000000000000000000000000000006',
    '0xD4a0e0b9149BCee3C920d2E00b5dE09138fd8bb7',
    '0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22',
    '0xcf3D55c10DB69f28fD1A75Bd73f3D8A2d9c595ad',
    '0xd9aAEc86B65D86f6A7B5B1b0c42FFA531710b6CA',
    '0x0a1d576f3eFeF75b330424287a95A366e8281D54',
    '0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452',
    '0x99CBC45ea5bb7eF3a5BC08FB1B7E56bB2442Ef0D',
    '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
    '0x4e65fE4DbA92790696d040ac24Aa414708F5c0AB',
    '0x04C0599Ae5A44757c0af6F9eC3b93da8976c150A',
    '0x7C307e128efA31F540F2E2d976C995E0B65F51F6',
    '0xBdb9300b7CDE636d9cD4AFF00f6F009fFBBc8EE6',
    '0x2416092f143378750bb29b79eD961ab195CcEea5',
    '0xDD5745756C2de109183c6B5bB886F9207bEF114D',
    '0x6Bb7a212910682DCFdbd5BCBb3e28FB4E8da10Ee',
    '0x067ae75628177FD257c2B1e500993e1a0baBcBd1',
    '0xEDfa23602D0EC14714057867A78d01e94176BEA0',
    '0x80a94C36747CF51b2FbabDfF045f6D22c1930eD1',
    '0xecAc9C5F704e954931349Da37F60E39f515c11c1',
    '0x90072A4aA69B5Eb74984Ab823EFC5f91e90b3a72',
    '0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42',
    '0x90DA57E0A6C0d166Bf15764E03b83745Dc90025B',
    '0x63706e401c06ac8513145b7687A14804d17f814b',
    '0x67EAF2BeE4384a2f84Da9Eb8105C661C123736BA',
    '0x236aa50979D5f3De3Bd1Eeb40E81137F22ab794b',
    '0xbcFFB4B3beADc989Bd1458740952aF6EC8fBE431',
    '0x660975730059246A68521a3e2FBD4740173100f5',
    '0xD7424238CcbE7b7198Ab3cFE232e0271E22da7bd',
    '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1',
    '0x82E64f49Ed5EC1bC6e43DAD4FC8Af9bb3A2312EE',
    '0xf97f4df75117a78c1A5a0DBb814Af92458539FB4',
    '0x191c10Aa4AF7C30e871E70C95dB0E4eb77237530',
    '0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8',
    '0x625E7708f30cA75bfd92586e17077590C60eb4cD',
    '0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f',
    '0x078f358208685046a11C85e8ad32895DED33A249',
    '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
    '0xe50fA9b3c56FfB159cB0FCA61F5c9D750e8128c8',
    '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
    '0x6ab707Aca953eDAeFBc4fD23bA73294241490620',
    '0xba5DdD1f9d7F570dc94a51479a000E3BCE967196',
    '0xf329e36C7bF6E5E86ce2150875a84Ce77f477375',
    '0xD22a58f79e9481D1a88e00c343885A588b34b68B',
    '0x6d80113e533a2C0fe82EaBD35f1875DcEA89Ea97',
    '0x5979D7b546E38E414F7E9822514be443A4800529',
    '0x513c7E3a9c69cA3e22550eF58AC1C0088e918FFf',
    '0x3F56e0c36d275367b8C502090EDF38289b3dEa0d',
    '0xc45A479877e1e9Dfe9FcD4056c699575a1045dAA',
    '0xEC70Dcb4A1EFa46b8F2D97C310C9c4790ba5ffA8',
    '0x8Eb270e296023E9D92081fdF967dDd7878724424',
    '0x93b346b6BC2548dA6A1E7d98E9a421B42541425b',
    '0x8ffDf2DE812095b1D19CB146E4c004587C0A0692',
    '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
    '0x724dc807b04555b71ed48a6896b6F41593b8C637',
    '0x17FC002b466eEc40DaE837Fc4bE5c67993ddBd6F',
    '0x38d693cE1dF5AaDF7bC62595A37D667aD57922e5',
    '0x912CE59144191C1204E64559FE8253a0e49E6548',
    '0x6533afac2E7BCCB20dca161449A13A32D391fb00',
    '0x35751007a407ca6FEFfE80b3cB397736D2cf4dbe',
    '0x8437d7C167dFB82ED4Cb79CD44B7a32A1dd95c77',
    '0x7dfF72693f6A4149b17e7C6314655f6A9F7c8B33',
    '0xeBe517846d0F36eCEd99C735cbF6131e1fEB775D',
    '0xEA1132120ddcDDA2F119e99Fa7A27a0d036F7Ac9',
    '0x4186BFC76E2E237523CBC30FD220FE055156b41F',
    '0x6b030Ff3FB9956B1B69f475B77aE0d3Cf2CC5aFa',
    '0x6c84a8f1c29108F47a79964b5Fe888D4f4D0dE40',
    '0x62fC96b27a510cF4977B59FF952Dc32378Cc221d',
    '0xd586E7F844cEa2F87f50152665BCbc2C279D8d70',
    '0x5947BB275c521040051D82396192181b413227A3',
    '0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E',
    '0x50b7545627a5162F82A992c33b87aDc75187B218',
    '0x49D5c2BdFfac6CE2BFdB6640F4F80f226bc10bAB',
    '0x9702230A8Ea53601f5cD2dc00fDBc13d4dF4A8c7',
    '0x63a72806098Bd3D9520cC43356dD78afe5D386D9',
    '0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7',
    '0x2b2C81e08f1Af8835a78Bb2A90AE924ACE0eA4bE',
    '0xD24C2Ad096400B6FBcd2ad8B24E7acBc21A1da64',
    '0x5c49b268c9841AFF1Cc3B0a418ff5c3442eE3F3b',
    '0x152b9d0FdC40C096757F570A51E494bd4b943E50',
    '0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a',
    '0xfc421aD3C883Bf9E7C4f42dE845C4e4405799e73',
    '0xf611aEb5013fD2c0511c9CD55c7dc5C1140741A6',
    '0xC891EB4cbdEFf6e073e859e987815Ed1505c2ACD',
    '0x8a9FdE6925a839F6B1932d16B36aC026F8d3FbdB',
    '0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34',
    '0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2',
    '0x44705f578135cC5d703b4c9c122528C73Eb87145',
    '0x7bFd4CA2a6Cf3A3fDDd645D10B323031afe47FF0',
    '0x40B4BAEcc69B882e8804f9286b12228C27F8c9BF',
    '0x50c42dEAcD8Fc9773493ED674b675bE577f2634b',
    '0xe18Ab82c81E7Eecff32B8A82B1b7d2d23F1EcE96',
    '0x29219dd400f2Bf60E5a23d13Be72B486D4038894',
    '0x578Ee1ca3a8E1b54554Da1Bf7C583506C4CD11c6',
    '0x039e2fB66102314Ce7b64Ce5Ce3E5183bc94aD38',
    '0x6C5E14A212c1C3e4Baf6f871ac9B1a969918c131',
    '0xE5DA20F15420aD15DE0fa650600aFc998bbE3955',
    '0xeAa74D7F42267eB907092AF4Bc700f667EeD0B8B',
    '0x350a791Bfc2C21F9Ed5d10980Dad2e2638ffa7f6',
    '0x7F5c764cBc14f9669B88837ca1490cCa17c31607',
    '0x68f180fcCe6836688e9084f035309E29Bf0A2095',
    '0x94b008aA00579c1307B0EF2c499aD98a8ce58e58',
    '0x76FB31fb4af56892A25e32cFC43De717950c9278',
    '0x8c6f28f2F1A3C87F0f938b96d27520d9751ec8d9',
    '0x4200000000000000000000000000000000000042',
    '0x1F32b1c2345538c0c6f582fCB022739c4A194Ebb',
    '0xc40F949F8a4e094D1b49a23ea9241D289B7b2819',
    '0xdFA46478F9e5EA86d57387849598dbFB2e964b02',
    '0x9Bcef72be871e61ED4fBbc7630889beE758eb81D',
    '0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85',
    '0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063',
    '0x53E0bca35eC356BD5ddDFebbD1Fc0fD03FaBad39',
    '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
    '0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6',
    '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619',
    '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
    '0xD6DF932A45C0f255f85145f286eA0b292B21C90B',
    '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270',
    '0x172370d5Cd63279eFa6d502DAB29171933a610AF',
    '0x0b3F868E0BE5597D5DB7fEB59E1CADBb0fdDa50a',
    '0x385Eeac5cB85A38A9a07A70c73e0a3271CfB54A7',
    '0x9a71012B13CA4d3D0Cdc72A177DF3ef03b0E76A3',
    '0x85955046DF4668e1DD369D2DE9f3AEB98DD2A369',
    '0xE111178A87A3BFf0c8d18DECBa5798827539Ae99',
    '0x4e3Decbb3645551B8A19f0eA1678079FCB33fB4c',
    '0xE0B52e49357Fd4DAf2c15e02058DCE6BC0057db4',
    '0xa3Fa99A148fA48D14Ed51d610c367C61876997F1',
    '0x3A58a54C066FdC0f2D55FC9C89F0415C92eBf3C4',
    '0xfa68FB4628DFF1028CFEc22b4162FCcd0d45efb6',
    '0x80cA0d8C38d2e2BcbaB66aA1648Bd1C7160500FE',
    '0x03b54A6e9a984069379fae1a4fC4dBAE93B3bCCD',
    '0xf59036CAEBeA7dC4b86638DFA2E3C97dA9FcCd40',
    '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359',
    '0xA4D94019934D8333Ef880ABFFbF2FDd611C762BD',
    '0x4c078361FC9BbB78DF910800A991C7c3DD2F6ce0',
    '0x85ABAdDcae06efee2CB5F75f33b6471759eFDE24',
    '0xDeadDeAddeAddEAddeadDEaDDEAdDeaDDeAD0000',
    '0x7314Ef2CA509490f65F52CC8FC9E0675C66390b8',
    '0xEA32A96608495e54156Ae48931A7c20f0dcc1a21',
    '0x885C8AEC5867571582545F894A5906971dB9bf27',
    '0xbB06DCA3AE6887fAbF931640f67cab3e3a16F4dC',
    '0xd9fa75D14c26720d5ce7eE2530793a823e8f07b9',
    '0x420000000000000000000000000000000000000A',
    '0x8acAe35059C9aE27709028fF6689386a44c09f3a',
    '0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1',
    '0xa818F1B57c201E092C4A2017A91815034326Efd1',
    '0x6C76971f98945AE98dD7d4DFcA8711ebea946eA6',
    '0x23e4E76D01B2002BE436CE8d6044b0aA2f68B68a',
    '0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb',
    '0xA1Fa064A85266E2Ca82DEe5C5CcEC84DF445760e',
    '0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83',
    '0xc6B7AcA6DE8a6044E0e32d0c841a89244A10D284',
    '0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d',
    '0xd0Dd6cEF72143E22cCED4867eb0d5F2328715533',
    '0xcB444e90D8198415266c6a2724b7900fb12FC56E',
    '0xEdBC7449a9b594CA4E053D9737EC5Dc4CbCcBfb2',
    '0xaf204776c7245bF4147c2612BF6e5972Ee483701',
    '0x7a5c3860a77a8DC1b225BD46d0fb2ac1C6D191BC',
    '0x2a22f9c3b484c3629090FeED35F17Ff8F88f76F0',
    '0xC0333cb85B59a788d8C7CAe5e1Fd6E229A3E5a65',
    '0x3FdCeC11B4f15C79d483Aedc56F37D302837Cf4d',
    '0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82',
    '0x4199CC1F5ed0d796563d7CcB2e036253E2C18281',
    '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    '0x9B00a09492a626678E5A3009982191586C444Df9',
    '0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c',
    '0x56a7ddc4e848EbF43845854205ad71D5D5F72d3D',
    '0x2170Ed0880ac9A755fd29B2688956BD959F933F8',
    '0x2E94171493fAbE316b6205f1585779C887771E2F',
    '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
    '0x00901a076785e0906d1028c7d6372d247bec7d61',
    '0x55d398326f99059fF775485246999027B3197955',
    '0xa9251ca9DE909CB71783723713B21E4233fbf1B1',
    '0xc5f0f7b66764F6ec8C8Dff7BA683102295E16409',
    '0x75bd1A659bdC62e4C313950d44A2416faB43E785',
    '0x26c5e01524d2E6280A48F2c50fF6De7e52E9611C',
    '0xBDFd4E51D3c14a232135f04988a42576eFb31519',
    '0x5300000000000000000000000000000000000004',
    '0xf301805bE1Df81102C957f6d4Ce29d2B8c056B2a',
    '0x06eFdBFf2a14a7c8E15944D1F4A48F9F95F663A4',
    '0x1D738a3436A8C49CefFbaB7fbF04B660fb528CbD',
    '0xf610A9dfB7C89644979b4A0f27063E9e7d7Cda32',
    '0x5B1322eeb46240b02e20062b8F0F9908d525B09c',
    '0x01f0a31698C4d065659b9bdC21B3610292a1c506',
    '0xd80A5e16DBDC52Bd1C947CEDfA22c562Be9129C8',
    '0xd29687c813D741E2F938F4aC377128810E217b1b',
    '0x25718130C2a8eb94e2e1FAFB5f1cDd4b459aCf64',
    '0xe5D7C2a44FfDDf6b295A15c148167daaAf5Cf34f',
    '0x787897dF92703BB3Fc4d9Ee98e15C0b8130Bf163',
    '0x3aAB2285ddcDdaD8edf438C1bAB47e1a9D05a9b4',
    '0x37f7E06359F98162615e016d0008023D910bB576',
    '0x176211869cA2b568f2A7D4EE941E073a821EE1ff',
    '0x374D7860c4f2f604De0191298dD393703Cce84f3',
    '0xA219439258ca9da29E9Cc4cE5596924745e12B93',
    '0x88231dfEC71D4FF5c1e466D08C321944A7adC673',
    '0xB5beDd42000b71FddE22D3eE8a79Bd49A568fC8F',
    '0x58943d20e010d9E34C4511990e232783460d0219',
    '0x935EfCBeFc1dF0541aFc3fE145134f8c9a0beB89',
    '0x1Bf74C010E6320bab11e2e5A532b5AC15e0b8aA6',
    '0x0C7921aB4888fd06731898b3fffFeB06781D5F4F',
    '0xD2671165570f41BBB3B0097893300b6EB6101E6C',
    '0xCDD80E6211FC767352B198f827200C7e93d7Bb04',
    '0x61B19879F4033c2b5682a969cccC9141e022823c',
    '0xcebA9300f2b948710d2653dD7B07f33A8B32118C',
    '0xFF8309b9e99bfd2D4021bc71a362aBD93dBd4785',
    '0x48065fbBE25f71C9282ddf5e1cD6D6A887483D5e',
    '0xDeE98402A302e4D707fB9bf2bac66fAEEc31e8Df',
    '0xD8763CBa276a3738E6DE85b4b3bF5FDed6D6cA73',
    '0x34c02571094e08E935B8cf8dC10F1Ad6795f1f81',
    '0x765DE816845861e75A25fCA122bb6898B8B1282a',
    '0xBba98352628B0B0c4b40583F593fFCb630935a45',
    '0x471EcE3750Da237f93B8E339c536989b8978a438',
    '0xC3e77dC389537Db1EEc7C33B95Cf3beECA71A209',
    '0xD221812de1BD094f35587EE8E174B07B6167D9Af',
    '0xf385280F36e009C157697D25E0B802EfaBfd789c',
    '0x1bD45Cc20CE61BE344A64218E6Ade01E72b08f39',
    '0xbA9986D2381edf1DA03B0B9c1f8b00dc4AacC369',
    '0xb2C9E934A55B58D20496A5019F8722a96d8A44d8',
    '0x3A337a6adA9d885b6Ad95ec48F9b75f197b5AE35',
    '0xBAB0366ADdA6d2845c6BB5db4339A824350d24F7',
    '0x1d17CBcF0D6D143135aE902365D2E5e2A16538D4',
    '0xE977F9B2a5ccf0457870a67231F23BE4DaecfbDb',
    '0x493257fD37EDB34451f62EDf8D2a0C418852bA4C',
    '0xC48574bc5358c967d9447e7Df70230Fdb469e4E7',
    '0x5AEa5775959fBC2557Cc8789bC1bf90A239D9a91',
    '0xb7b93bCf82519bB757Fd18b23A389245Dbd8ca64',
    '0x703b52F2b28fEbcB60E1372858AF5b18849FE867',
    '0xd4e607633F3d984633E946aEA4eb71f92564c1c9',
    '0x5A7d6b2F92C77FAD6CCaBd7EE0624E64907Eaf3E',
    '0xd6cD2c0fC55936498726CacC497832052A9B2D1B',
    '0xc1Fa6E2E8667d9bE0Ca938a54c7E0285E9Df924a',
    '0xE818A67EE5c0531AFaa31Aa6e20bcAC36227A641',
    '0xAD17Da2f6Ac76746EF261E835C50b2651ce36DA8',
    '0xF3c9d58B76AC6Ee6811520021e9A9318c49E4CFa',
    '0xd4169E045bcF9a86cC00101225d9ED61D2F51af2',
    '0x5722921bb6C37EaEb78b993765Aa5D79CC50052F',
    '0xdEAddEaDdeadDEadDEADDEAddEADDEAddead1111',
    '0xeAC30Ed8609F564aE65C809C4bf42dB2fF426D2C',
    '0x78c1b0C915c4FAA5FffA6CAbf0219DA63d7f4cb8',
    '0x85d86061e94CE01D3DA0f9EFa289c86ff136125a',
    '0x779Ded0c9e1022225f8E0630b35a9b54bE713736',
    '0x7053bAD224F0C021839f6AC645BdaE5F8b585b69',
    '0x09Bc4E0D864854c6aFB6eB9A9cdF58aC190D0dF9',
    '0xcb8164415274515867ec43CbD284ab5d6d2b304F',
    '0xb9aCA933C9c0aa854a6DBb7b12f0CC3FdaC15ee7',
    '0xaf972F332FF79bd32A6CB6B54f903eA0F9b16C2a',
    '0xfa14c9DE267b59A586043372bd98Ed99e3Ee0533',
    '0x051665f2455116e929b9972c36d23070F5054Ce0',
    '0xF8400F3FA9cD9F9E84e93cD9De9f14EB7B5b59b5',
    '0x93e855643e940D025bE2e529272e4Dbd15a2Cf74',
    '0x5cC6999aC46F4627309a7ce0F321a3f45D138ED5',
    '0x8917d4eE4609f991b559DAF8D0aD1b892c13B127',
    '0xa31E6b433382062e8A1dA41485f7b234D97c3f4d',
    '0x0889d59eA7178ee5B71DA01949a5cB42aaFBe337',
    '0xB8CE59FC3717ada4C02eaDF9682A9e934F625ebb',
    '0xE2283E01a667b512c340f19B499d86fbc885D5Ef',
    '0xFAfDdbb3FC7688494971a79cc65DCa3EF82079E7',
    '0x5dF82810CB4B8f3e0Da3c031cCc9208ee9cF9500',
    '0x601aC63637933D88285A025C685AC4e9a92a98dA',
    '0xaD2de503b5c723371d6B38A5224A2E12E103DfB8',
    '0x4Fc44BE15e9B6E30C1E774E2C87A21D3E8b5403F',
    '0xb8578af311353b44B14bb4480EBB4DE608EC7e1B',
    '0x09601A65e7de7BC8A19813D263dD9E98bFdC3c57',
    '0x03C99Cce547b1c2E74442b73E6f588A66D19597e',
    '0x78f2cB75D664d6f71433174056c25A5958B4016F',
    '0x5D72a9d9A9510Cd8cBdBA12aC62593A58930a948',
    '0x7519403E12111ff6b710877Fcd821D0c12CAF43A',
    '0xC1A318493fF07a68fE438Cee60a7AD0d0DBa300E',
    '0x1B64B9025EEbb9A6239575dF9Ea4b9Ac46D4d193',
    '0x5c43D6C075C7CF95fb188FB2977eeD3E3F2a92c2',
    '0xA3D68b74bF0528fdD07263c60d6488749044914b',
    '0xAf1a7a488c8348b41d5860C04162af7d3D38A996',
    '0x9895D81bB462A195b4922ED7De0e3ACD007c32CB',
    '0xf1aB7f60128924d69f6d7dE25A20eF70bBd43d07',
    '0x93B544c330F60A2aa05ceD87aEEffB8D38FD8c9a',
    '0xEa601A9FECF80bFC529F08A51bD8Cb0d72fc862A',
    '0x02FCC4989B4C9D435b7ceD3fE1Ba4CF77BBb5Dd8',
    '0x0b9A412c94f07223752031f75a20DDe542D63d5C',
    '0xe48D935e6C9e735463ccCf29a7F11e32bC09136E',
    '0x140Bc58975DFba4D30fE65c4F6262a6c314683cf',
    '0xe561FE05C39075312Aa9Bc6af79DdaE981461359',
    '0x41c7aCCC0fB97470bFB48014bad52E0d99447E79',
    '0xC4374775489CB9C56003BF2C9b12495fC64F0771',
    '0xD4eE376C40EdC83832aAaFc18fC0272660F5e90b',
    '0x6100E367285b01F48D07953803A2d8dCA5D19873',
    '0x5aA4bc74811D672DA5308019dA4779f673e60B47',
    '0xab509448ad489e2E1341e25CC500f2596464Cc82',
    '0x53349cBeD7A3F851f0722Bf3Fa8f1b93fA939BeF',
    '0x54Dc267be2839303ff1e323584A16e86CeC4Aa44',
    '0x9326fA5a71C93D5De313c91C3b80D74d0c3a0F5A',
    '0xb77E872A68C62CfC0dFb02C067Ecc3DA23B4bbf3',
    '0xAd571979b4245E163A7E2119EB4dFd94AfDaebC5',
    '0x23B17d3944742ACe3d0C71586FcB320d1e4a1Ed2',
    '0xDEdFF537fCBa1169E673F78EE23D109885741016',
    '0x30559E3d35e33AB69399a3fe9F383d32bd3c016E',
    '0x68ab954Dc705c66506d499963dD1fbB8aFa23d7d',
    '0x946281A2d0DD6e650d08f74833323D66AE4c8b12',
    '0x68215B6533c47ff9f7125aC95adf00fE4a62f79e',
    '0xE3190143Eb552456F88464662f0c0C4aC67A77eB',
    '0x43415eB6ff9DB7E26A15b704e7A3eDCe97d31C4e',
    '0x4E58a2E433A739726134c83d2f07b2562e8dFdB3',
    '0x14d60E7FDC0D71d8611742720E4C50E7a974020c',
    '0x08b798c40b9AB931356d9aB4235F548325C4cb80',
    '0x136471a34f6ef19fE571EFFC1CA711fdb8E49f2b',
    '0xc167932AC4EEc2B65844EF00D31b4550250536A5',
    '0x8c213ee79581Ff4984583C6a801e5263418C4b86',
    '0x844f07AB09aa5dBDCE6A9b1206CE150E1eaDacCb',
    '0x5a0F93D040De44e78F251b03c43be9CF317Dcf64',
    '0xB0EC6c4482Ac1Ef77bE239C0AC833CF37A27c876',
    '0x2255718832bC9fD3bE1CaF75084F4803DA14FF01',
    '0xE1CfD16b8E4B1C86Bb5b7A104cfEFbc7b09326dD',
    '0x17418038ecF73BA4026c4f428547BF099706F27B',
    '0xc293744fFbcf46696D589f5C415e71BC491519cD',
    '0x2B35eF056728BaFFaC103e3b81cB029788006EF9',
    '0x73E0C0d45E048D25Fc26Fa3159b0aA04BfA4Db98',
    '0xC712C3a5624de08EA593FB23270804B47942564e',
    '0x0200C29006150606B650577BBE7B6248F58470c1',
    '0x99cBF1Ff4527675Ed3301671105C9F7748fb8a04',
    '0x4cd13ce4edbB5523fd4849252b5f1bF215129D10',
    '0xC629140A8aA21F8f319A21F41b2DC1b0431693C1',
    '0x2D270e6886d130D724215A266106e6832161EAEd',
    '0x70A38B0c90441e991346B7A0Cd98C8528dD1c234',
    '0x7789888E302Bc3288A78a182efe6DfE91da756ec',
    '0x9f0a74A92287E323Eb95c1cd9eCdBEb0e397cAe4',
    '0x98F6A9b82799813447E6c00E51aF5b325976199A',
    '0xd596B3C15E28795AaBF0481DaA0Ff4eBAa42c5F2',
    '0x24C1FaC3447C45137E5f1c2C54Fe9ed3F1EdeA61',
    '0x726D965F0D759A0489d178365f00b4c3c3207BB7',
    '0xaE4EFbc7736f963982aACb17EFA37fCBAb924cB3',
    '0x0373715A7e8f77354B4Af002C6f9F33C79f4F92a',
    '0x8A76fe7fA6da27f85a626c5C53730B38D13603d7',
    '0x9d97196e7e6652e82C2F0FE93a9B3876E3d8528e',
    '0xF356ae412dB5df43BD3a10746f7ad4e1C4De4297',
    '0x4ae46a509F6b1D9056937BA4500cb143933D2dc8',
    '0x228765a3C18065C923F23a0CCb6c7cEFB3eA2223',
    '0xb7C00000bcDEeF966b20B3D884B98E64d2b06b4f',
    '0xF5F9d4e9e2AFe7E0b193d291Befb41d61930464e',
    '0xe538905cf8410324e03A5A23C1c177a474D59b2b',
    '0x3ea3A4038FbA5757A9A68de920b44698d7326A59',
    '0xE7B000003A45145decf8a28FC755aD5eC5EA025A',
    '0xe6639ba6c1d79Be6d4c776E4c17504538d1719cD',
    '0x505000008DE8748DBd4422ff4687a4FC9bEba15b',
    '0x523dCe1b164327818fc5B41278fAe41f6B5753FE',
    '0xAFeab3B85B6A56cF5F02317F0f7A23340eb983D7',
    '0xe9e78053f1Ef084f8cD01dBE8ccE95c6b0944d32',
    '0x14a686103854DAB7b8801E31979CAA595835B25d',
    '0x38811564090aAb7bB455c5b771e26201a3535a01',
    '0xDe6539018B095353A40753Dc54C91C68c9487D4E',
    '0x77188335A21f4C409d2CfeDe3195A7B5f28651b0',
    '0x04EADd7B10ea9a484c60860aea7A7C0AEc09B9F0',
    '0x3a4de44B29995a3D8Cd02d46243E1563E55bCc8b',
    '0xDcC1bcC6eCD1E63cBA178C289bC1dA9f757a2eF4',
    '0x503D751B13a71D8e69Db021DF110bfa7aE1dA889',
    '0x0AD8ac496B4280bC3B36fb1b6372abdEc8eE7C54',
    '0xb8021254f00C1aFb67b861f274cea175FB97c2Af',
    '0x2c63f9da936624Ac7313b972251D340260A4bF08',
    '0x72eEED8043Dcce2Fe7CdAC950D928F80f472ab80',
    '0xb542b71Bf6A5e907d7A1B34553b47a25cab47F3e',
    '0x3B50805453023a91a8bf641e279401a0b23FA6F9',
    '0x63dC02BB25E7BF7Eaa0E42E71D785a388AcD740b',
    '0x0f1eb8D5568E9C1ee72E6dE7B5a9e2837A530019',
    '0xFe0c30065B384F05761f15d0CC899D4F9F9Cc0eB',
    '0x9421F7A094c299AF6d4451E68bA7bEC09a8a062D',
    '0x4e5e8A75455Ae94Fa8fd6dbf28Ed4D609684f2CF',
    '0x3D6d9D386feAba912E5cAD20770b3D797258Ed7d',
    '0x30D20208d987713f46DFD34EF128Bb16C404D10f',
    '0xB0217F23552b6F3057A451b4C24EE838387d2b53',
    '0x46B47dd45F7d96562f4Bb8891d80CA2cC024CE19',
    '0x954eC713a3915B504a6F288563e5218F597e1895',
    '0x0A04dc9cBf6cf3BB216f24a501994eFfB2Aa8F6f',
    '0xa002b7AaF8499e4899dBaa4867726787758296b1',
    '0x53Bf7B3DCf81d6AF354147698Fce45b847649E2a',
    '0xADe80a8a6132ac12Bcc4a80De2EF618B59700047',
    '0x1a23b27aC7775B6220dC4F816b5c6A629E371f19',
    '0x28B7E77f82B25B95953825F1E3eA0E36c1c29861',
    '0x7f5d3Abaf4Eed71c0feC01342D204dC8c9a4A36B',
    '0x58a6d21fd258166FF058bb4488a77B7308DDd514',
    '0x09E4C43B7Ce78AC58fF6A920f1fD5D84a7975f78',
  ],
  additionalIncentiveInfo: {
    '1-0x4F5923Fc5FD4a93352581b38B7cD26943012DECF': {
      customMessage:
        'You must supply USDe and hold an equal or greater amount of sUSDe (by USD value) to receive the incentives. To be eligible, your assets supplied must be at least 2x your account equity, and you must not be borrowing any USDe. The rate provided to eligible users will change week by week, but will be roughly in line with the sUSDe rate less the USDe supply rate earned for the foreseeable future.',
    },
    '9745-0x7519403E12111ff6b710877Fcd821D0c12CAF43A': {
      customMessage:
        'You must supply USDe and hold an equal or greater amount of sUSDe (by USD value) to receive the incentives. To be eligible, your assets supplied must be at least 2x your account equity, and you must not be borrowing any USDe. The rate provided to eligible users will change week by week, but will be roughly in line with the sUSDe rate less the USDe supply rate earned for the foreseeable future.',
    },
    '5000-0xb9aCA933C9c0aa854a6DBb7b12f0CC3FdaC15ee7': {
      customMessage:
        'You must supply USDe and hold an equal or greater amount of sUSDe (by USD value) to receive the incentives. To be eligible, your assets supplied must be at least 2x your account equity, and you must not be borrowing any USDe. The rate provided to eligible users will change week by week, but will be roughly in line with the sUSDe rate less the USDe supply rate earned for the foreseeable future.',
    },
    '4326-0x78f2cB75D664d6f71433174056c25A5958B4016F': {
      customMessage:
        'You must supply USDe to receive the incentives. To be eligible, your assets supplied must be at least 2x your account equity, and you must not be borrowing any USDe. The rate provided to eligible users will change week by week, but will be roughly in line with the sUSDe rate less the USDe supply rate earned for the foreseeable future.',
    },
    '1-0xEc4ef66D4fCeEba34aBB4dE69dB391Bc5476ccc8': {
      customMessage:
        'You must supply USDtb to receive incentives. To be eligible, you must not be borrowing any USDtb.',
      customClaimMessage: 'Rewards will be claimable starting in early August.',
      customForumLink: 'https://x.com/ethena_labs/status/1950194502192550149',
    },
    '1-0x0C0d01AbF3e6aDfcA0989eBbA9d6e85dD58EaB1E': {
      customMessage:
        'You need to supply PYUSD without holding any PYUSD debt. This is a program initiated and implemented by ACI in collaboration with Merkl.',
    },
    '1-0x6c82c66622Eb360FC973D3F492f9D8E9eA538b08': {
      customMessage:
        'You need to borrow EURC without holding aEURC. This is a program initiated and implemented by ACI in collaboration with Merkl.',
    },
    '42161-0xe50fA9b3c56FfB159cB0FCA61F5c9D750e8128c8': {
      customMessage:
        'You must supply WETH without holding any WETH debt. This is a program initiated and implemented by the Arbitrum DAO in collaboration with Merkl.',
    },
    '42161-0x0c84331e39d6658Cd6e6b9ba04736cC4c4734351': {
      customMessage:
        'You must supply wstETH, weETH, ezETH, or rsETH as the collateral for the ETH borrow position in order to be eligible for rewards. This is a program initiated and implemented by the Arbitrum DAO in collaboration with Merkl.',
    },
    '324-0xb7b93bCf82519bB757Fd18b23A389245Dbd8ca64': {
      customMessage:
        'You must supply wETH without holding any wETH debt. You must have an HF lower than 1.75. This is a program initiated and implemented by ACI in collaboration with Merkl.',
    },
    '324-0x98dC737eA0E9bCb254c3F98510a71c5E11F74238': {
      customMessage:
        'You need to borrow wETH without holding wETH as collateral. You must have an HF lower than 1.75. This is a program initiated and implemented by ACI in collaboration with Merkl.',
    },
    '324-0x0049250D15A8550c5a14Baa5AF5B662a93a525B9': {
      customMessage:
        'You need to borrow USDC without holding USDC as collateral. This is a program initiated and implemented by ACI in collaboration with Merkl.',
    },
    '324-0x6aD279F6523f6421fD5B0324a97D8F62eeCD80c8': {
      customMessage:
        'You need to borrow wstETH without holding wstETH as collateral. You must have an HF lower than 1.75. This is a program initiated and implemented by ACI in collaboration with Merkl.',
    },
    '534352-0x3d2E209af5BFa79297C88D6b57F89d792F6E28EE': {
      customMessage:
        'You need to borrow USDC without holding USDC as collateral. This is a program initiated and implemented by ACI in collaboration with Merkl.',
    },
    '534352-0xf301805bE1Df81102C957f6d4Ce29d2B8c056B2a': {
      customMessage:
        'You must supply wETH without holding any wETH debt. You must have an HF lower than 1.75. This is a program initiated and implemented by ACI in collaboration with Merkl.',
    },
    '9745-0x5D72a9d9A9510Cd8cBdBA12aC62593A58930a948': {
      customMessage:
        'You need to supply USDT0 without holding any USDT0, USDe, or GHO debt. This is a program initiated and implemented by ACI in collaboration with Merkl.',
    },
    '9745-0xCBBC427b5658672768E11BFDa00879839DB4785F': {
      customMessage:
        'You need to borrow USDT0 without holding USDT0 or GHO as collateral. This is a program initiated and implemented by ACI in collaboration with Merkl.',
    },
    '9745-0xAd571979b4245E163A7E2119EB4dFd94AfDaebC5': {
      customMessage:
        'You need to supply GHO without holding any USDT0, USDe, or GHO debt. This is a program initiated and implemented by ACI in collaboration with Merkl.',
    },
    '9745-0xf1aB7f60128924d69f6d7dE25A20eF70bBd43d07': {
      customMessage:
        'You need to supply wETH without holding any wETH debt. This is a program initiated and implemented by ACI in collaboration with Merkl.',
    },
    '1-0x24Ab03a9a5Bc2C49E5523e8d915A3536ac38B91D': {
      customMessage:
        'You need to supply syrupUSDT and borrow USDT to be eligible to this incentive campaign. This is a program initiated and implemented by ACI in collaboration with Merkl.',
    },
    '8453-0xD7424238CcbE7b7198Ab3cFE232e0271E22da7bd': {
      customMessage:
        'You need to supply syrupUSDC and borrow USDC to be eligible to this incentive campaign. This is a program initiated and implemented by ACI in collaboration with Merkl.',
    },
    '1-0x7c0477d085ECb607CF8429f3eC91Ae5E1e460F4F': {
      customMessage:
        'You need to supply USDG without holding any USDG debt. This is a program initiated and implemented by ACI in collaboration with Merkl and Paxos.',
    },
    '5000-0x7053bAD224F0C021839f6AC645BdaE5F8b585b69': {
      customMessage:
        'You need to supply USDT0 without holding any Stablecoin USD debt. This is a program initiated and implemented by ACI in collaboration with Merkl and Mantle.',
    },
    '5000-0xcb8164415274515867ec43CbD284ab5d6d2b304F': {
      customMessage:
        'You need to supply USDC without holding any Stablecoin USD debt. This is a program initiated and implemented by ACI in collaboration with Merkl and Mantle.',
    },
    '5000-0x8917d4eE4609f991b559DAF8D0aD1b892c13B127': {
      customMessage:
        'You need to supply GHO without holding any Stablecoin USD debt. This is a program initiated and implemented by ACI in collaboration with Merkl and Mantle.',
    },
    '5000-0x5cC6999aC46F4627309a7ce0F321a3f45D138ED5': {
      customMessage:
        'You need to supply wrsETH. If you have already supplied the token on any other chain, you will not be eligible for the rewards. Only new supplies made on Mantle during the campaign qualify. This is a program initiated and implemented by ACI in collaboration with Merkl and Kelp.',
    },
    '1-0x2D62109243b87C4bA3EE7bA1D91B0dD0A074d7b1': {
      customMessage:
        'You need to supply wrsETH. Only new rsETH supplies made on Ethereum after timestamp 1775174400 qualify. This is a program initiated and implemented by ACI in collaboration with Merkl and Kelp.',
    },
    '4326-0x5dF82810CB4B8f3e0Da3c031cCc9208ee9cF9500': {
      customMessage:
        'You need to supply USDm without holding any USDm debt. This is a program initiated and implemented by ACI in collaboration with Merkl and MegaETH.',
    },
  },
};
